import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { FooterType } from 'src/app/domain/interfaces/footer/footer-type-enum';
import { Brand } from 'src/app/domain/models/funnel/brand-enum';
import { EverflowOfferId } from 'src/app/domain/models/funnel/funnel-page-enum';
import { FunnelStep } from 'src/app/domain/models/funnel/funnel-step-enum';
import { FunnelFlow } from 'src/app/domain/models/funnel/register-funnels/funnel-flow-register';
import { SourceOfDomain } from 'src/app/domain/models/resources/source-of-domain-enum';
import { BrandService } from 'src/app/infraestructure/drive-adapter/brand-service/brand.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() currentUpsellProductIndex: number = 0;
  @Input() FunnelFlow: FunnelFlow = { Step: FunnelStep.Upsell, UpsellsProducts: [{}] };
  @Input() showIconInc5000: boolean = false;
  public currentYear: number = new Date().getFullYear();
  @Input() IsCustomDefault: boolean = false;
  public IsOrganicFunnel!: boolean;
  public brandResources!: IBrandResources;
  public showClassVerify = false;
  @Input() footerType: FooterType = FooterType.Basic;
  public FooterTypes = FooterType;
  private brandServiceSubcription!: Subscription;
  @Input() IsDeclinePage: boolean = false;

  constructor(private brandService: BrandService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.brandServiceSubcription = this.brandService.getBrandResources().subscribe((brandResourcesResponse: IBrandResources) => {
      this.brandResources = brandResourcesResponse;
      this.showClassVerify = brandResourcesResponse?.domains && brandResourcesResponse?.domains?.some(domain => domain.includes(SourceOfDomain.VerifyFinancialProfile)) || false;
      this.route.queryParams.subscribe((params: Params) => {
        this.IsOrganicFunnel = params?.oid == brandResourcesResponse?.organicFunnelOfferId || params.oid == EverflowOfferId.OfferId_1065.toString();
        
        if(this.brandResources?.brand?.toString() == Brand[Brand.Finsights] && this.footerType == FooterType.Basic) {
          this.footerType = FooterType.MemberPortalFinsights;
        }

      });
    });
  }

  OngOnDestroy() {
    this.brandServiceSubcription?.unsubscribe();
  }
}

